module.exports = __webpack_public_path__ + "static/media/home_page_philosophy_background@768.ffc33c13.png";